var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mission-notches"},_vm._l((_vm.missions),function(mission,idx){return _c('div',{key:idx,staticClass:"notch",class:{
               active: mission.active,
               battling: mission.battling,
               won: mission.won
             }})}),0)}
var staticRenderFns = []

export { render, staticRenderFns }